"use client";

import { RootProduct } from "@/lib/centra/formatters";
import { usePricelist } from "@/lib/hooks/useCentra";
import { formatPrice } from "@/lib/utils/price";

type PriceType =
  | number
  | (
      | {
          priceListId?: string | undefined;
          price?: number | null | undefined;
        }
      | undefined
    )[]
  | null
  | undefined;

interface IPriceProps {
  pricelist: RootProduct["pricelist"] | undefined;
}

const Price = ({ pricelist }: IPriceProps) => {
  const { data: pricelistId } = usePricelist();
  if (!pricelist) return null;

  const foundPricelist = pricelist[pricelistId!];

  if (!foundPricelist) {
    return null;
  }

  const price = foundPricelist.price;
  const priceBeforeDiscount = foundPricelist.priceBeforeDiscount;
  const isOnSale = foundPricelist.showAsOnSale || price !== priceBeforeDiscount;

  return (
    <strong data-layout="price">
      {formatPrice(price)}{" "}
      {isOnSale && <span>{formatPrice(priceBeforeDiscount)}</span>}
    </strong>
  );
};

export default Price;
